import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["originalItem"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import { request, sleep } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { orderStatus, casingWines, purchaseOrder, listContinents, paymentState, STOCK_PART } from "@/js/lists.ts";
import { getErrorData } from "@/js/forms.js";
import { wineNaming } from "@/js/wine/wine.js";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  components: {
    MailTemplateModal: MailTemplateModal,
    MailTemplateForm: MailTemplateForm,
    Confirm: Confirm
  },
  props: {
    loggedUserData: Object,
    isShown: false,
    dialog: Boolean,
    order: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      drawer: false,
      drawerWidth: "45%",
      isSourcingAvailable: false,
      steps: [],
      currentStep: 1,
      openedPanel: 0,
      isStatelessDrawer: true,
      isValidating: false,
      mergeOrderCancellationToken: null,
      form: {
        toOrderId: null,
        forOrderItems: [],
        emailTemplates: [{
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }]
      },
      quantityToggleKey: false,
      filterIntegerKey: filterIntegerKey,
      isLoadingToOrder: false,
      toOrder: {},
      itemsSearchLabel: null,
      itemsShown: [],
      templateModalShown: false,
      editableTemplate: {},
      emailPlaceholders: {},
      emailTemplates: [],
      isSuccessfulSending: {},
      hasFailedSending: false,
      failedCustomMails: {},
      isDeletingTemplate: false,
      documents: [],
      isLoadingFiles: false,
      isSyncing: false,
      isNeedingSync: false,
      isSendNotificationMails: false,
      casingWines: casingWines,
      purchaseOrder: purchaseOrder,
      URL: URL,
      STOCK_PART: STOCK_PART
    };
  },
  computed: {
    isInvalidMainForm: function isInvalidMainForm() {
      if (!this.form.toOrderId) return true;
      if (!this.hasItemsChosen) return true;
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo;
        return !x.id || !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
      };
      if (this.form.emailTemplates.some(nullishPredicate)) return true;
      return false;
    },
    errorsMainForm: function errorsMainForm() {
      if (this.isInvalidMainForm) {
        var errors = [];
        if (!this.form.toOrderId) {
          errors.push("You must select the order destination.");
        }
        if (!this.hasItemsChosen) {
          errors.push("You must select at least one item to merge.");
        }
        var nullishPredicate = function nullishPredicate(x) {
          var _x$sendTo2;
          return !x.id || !x.from || !((_x$sendTo2 = x.sendTo) !== null && _x$sendTo2 !== void 0 && _x$sendTo2.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
        };
        if (this.form.emailTemplates.some(nullishPredicate)) errors.push("At least one mail configured is still not set correctly. You should delete it, or configure it completely.");
        return errors;
      }
      return null;
    },
    hasItemsChosen: function hasItemsChosen() {
      return this.form.forOrderItems.length > 0;
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    }
  },
  watch: {
    isShown: function () {
      var _isShown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(visible) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.drawer = visible;
              this.closureAttempt = 0;
              if (visible) {
                this.itemsSearchLabel = null;
                this.initStep();
                this.initForOrderItems();
                this.toOrder = {};
                this.fetchEmailPlaceholders();
                this.fetchEmailTemplates();
                this.fetchOrderDocuments();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function isShown(_x) {
        return _isShown.apply(this, arguments);
      }
      return isShown;
    }(),
    currentStep: function currentStep(_currentStep) {
      if (this.steps.filter(function (x) {
        return ["items", "mail"].includes(x.key);
      }).map(function (x) {
        return x.id;
      }).includes(_currentStep)) {
        this.drawerWidth = "80%";
      } else {
        this.drawerWidth = "45%";
      }
      if (_currentStep == this.steps.find(function (x) {
        return x.key == "items";
      }).id) {
        this.itemsSearch();
      }
    }
  },
  created: function created() {
    this.fetchOrdersAvailable();
    var canAccessPoData = hasRole(process.env.VUE_APP_ROLES_ACCESS_SOURCING) || hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
    this.isSourcingAvailable = this.$whitelabel.isAllowedToAccessPurchaseOrder && canAccessPoData;
  },
  methods: {
    validateMain: function validateMain() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isConfirmed, _this2$mergeOrderCanc, items, data, _this, path, _, _loop, i;
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this2.$refs.confirm.open("Order merge", "Are you sure about this order merge ?");
            case 2:
              isConfirmed = _context5.sent;
              if (!isConfirmed) {
                _context5.next = 22;
                break;
              }
              _this2.isValidating = true;
              (_this2$mergeOrderCanc = _this2.mergeOrderCancellationToken) === null || _this2$mergeOrderCanc === void 0 || _this2$mergeOrderCanc.cancel();
              _this2.mergeOrderCancellationToken = axios.CancelToken.source();
              items = _this2.form.forOrderItems.map(function (_ref) {
                var originalItem = _ref.originalItem,
                  item = _objectWithoutProperties(_ref, _excluded);
                return item;
              });
              data = {
                toOrderId: _this2.form.toOrderId,
                items: items
              };
              _this = _this2;
              path = "/v1/orders/" + _this.order.id_order + "/merge";
              _context5.next = 13;
              return request(path, "post", data, true, "api", null, _this.mergeOrderCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, null, true);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                _this.isValidating = false;
                throw e;
              });
            case 13:
              _ = _context5.sent;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var template, formData, _this;
                return _regeneratorRuntime().wrap(function _loop$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      template = _this2.form.emailTemplates[i];
                      template.templateId = template.id;
                      formData = new FormData();
                      Object.keys(template).forEach(function (key) {
                        return formData.append(key, template[key]);
                      });
                      template.files.forEach(function (x) {
                        formData.append("files", !x.blob ? x : new File([x.blob], x.id));
                      });
                      _this = _this2;
                      _context4.next = 8;
                      return request("/v1/mail/send", "post", formData, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              _this.isSuccessfulSending = _objectSpread(_objectSpread({}, _this.isSuccessfulSending), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                              _context2.next = 3;
                              return sleep(100);
                            case 3:
                            case "end":
                              return _context2.stop();
                          }
                        }, _callee2);
                      }))).catch(/*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
                          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                            while (1) switch (_context3.prev = _context3.next) {
                              case 0:
                                _this.hasFailedSending = true;
                                _this.failedCustomMails = _objectSpread(_objectSpread({}, _this.failedCustomMails), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                                _context3.next = 4;
                                return sleep(100);
                              case 4:
                              case "end":
                                return _context3.stop();
                            }
                          }, _callee3);
                        }));
                        return function (_x2) {
                          return _ref3.apply(this, arguments);
                        };
                      }());
                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 16:
              if (!(i < _this2.form.emailTemplates.length)) {
                _context5.next = 21;
                break;
              }
              return _context5.delegateYield(_loop(i), "t0", 18);
            case 18:
              i++;
              _context5.next = 16;
              break;
            case 21:
              _this2.acknowledgeValidation();
            case 22:
            case "end":
              return _context5.stop();
          }
        }, _callee4);
      }))();
    },
    acknowledgeValidation: function acknowledgeValidation() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this3.$emit("validate", _this3.form.toOrderId, true, function () {
                if (!_this3.hasFailedSending) _this3.$emit("close", true);
                _this3.isValidating = false;
                _this3.$toasted.show("Order succesfully merged.", {
                  type: "success"
                });
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee5);
      }))();
    },
    initForOrderItems: function initForOrderItems() {
      this.form.toOrderId = null;
      this.toOrder = {};
      this.form.forOrderItems = [];
      this.itemsShown = [];
    },
    itemsSearch: function itemsSearch() {
      var _this4 = this;
      var result = [];
      if (!this.itemsSearchLabel) {
        result = _toConsumableArray(this.order.items);
      } else {
        result = this.order.items.filter(function (item) {
          return String.removeDiacritics(_this4.itemsSearchLabel).toLowerCase().split(" ").every(function (x) {
            var _item$wine, _item$wine2;
            return String.removeDiacritics(((_item$wine = item.wine) === null || _item$wine === void 0 ? void 0 : _item$wine.display_name) + " " + ((_item$wine2 = item.wine) === null || _item$wine2 === void 0 ? void 0 : _item$wine2.sku)).toLowerCase().includes(x);
          }) || _this4.form.forOrderItems.map(function (x) {
            return x.fromItemId;
          }).includes(item.id_item);
        });
      }
      result.map(function (item) {
        var _this4$toOrder;
        item.isInNewOrder = _this4.form.forOrderItems.some(function (x) {
          return x.fromItemId == item.id_item;
        });
        if (((_this4$toOrder = _this4.toOrder) === null || _this4$toOrder === void 0 || (_this4$toOrder = _this4$toOrder.items) === null || _this4$toOrder === void 0 ? void 0 : _this4$toOrder.length) > 0) {
          //Check if the idStock is the same for the two orders

          var isDestinationStockNotCompatible = false;
          var itemDestinationOrder = _this4.toOrder.items.find(function (x) {
            return x.id_wine == item.id_wine;
          });
          if (itemDestinationOrder) {
            isDestinationStockNotCompatible = itemDestinationOrder.wine.id_stock != item.wine.id_stock;
          }
          item.isDestinationStockNotCompatible = isDestinationStockNotCompatible;
          if (item.isInNewOrder && item.isDestinationStockNotCompatible) {
            var itemForOrder = _this4.form.forOrderItems.find(function (x) {
              return x.fromItemId == item.id_item;
            });
            _this4.form.forOrderItems.splice(_this4.form.forOrderItems.indexOf(itemForOrder), 1);
            item.isInNewOrder = false;
          }
        } else {
          item.isDestinationStockNotCompatible = false;
        }
      });
      result.sort(function (a, b) {
        return b.isInNewOrder && !a.isInNewOrder ? 1 : -1;
      });
      this.itemsShown = result;
    },
    pickAllItems: function pickAllItems() {
      var _this5 = this;
      this.itemsSearchLabel = "";
      this.itemsSearch();
      this.itemsShown.forEach(function (item) {
        _this5.changeQuantityForOrder(item, item.quantity / item.casingId.match(/\d+/)[0]);
      });
    },
    unpickAllItems: function unpickAllItems() {
      var _this6 = this;
      this.itemsSearchLabel = "";
      this.itemsSearch();
      this.itemsShown.forEach(function (item) {
        _this6.changeQuantityForOrder(item, 0);
      });
    },
    changeQuantityForOrder: function changeQuantityForOrder(item, nbCases) {
      var nbBottles = nbCases * item.casingId.match(/\d+/)[0];
      if (nbBottles <= item.quantity) {
        if (nbBottles > 0) {
          if (this.form.forOrderItems.some(function (x) {
            return x.fromItemId === item.id_item;
          })) {
            this.form.forOrderItems.find(function (x) {
              return x.fromItemId === item.id_item;
            }).nbBottles = nbBottles;
          } else {
            this.form.forOrderItems = [].concat(_toConsumableArray(this.form.forOrderItems), [{
              fromItemId: item.id_item,
              nbBottles: nbBottles,
              originalItem: item
            }]);
          }
        } else {
          var itemToRemove = this.form.forOrderItems.find(function (x) {
            return x.fromItemId === item.id_item;
          });
          if (itemToRemove) {
            this.form.forOrderItems.splice(this.form.forOrderItems.indexOf(itemToRemove), 1);
          }
        }
        this.itemsSearch();
      }
      this.quantityToggleKey = !this.quantityToggleKey;
    },
    fetchOrdersAvailable: function fetchOrdersAvailable() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this7;
              data = {
                id_user: _this7.order.id_user,
                status_allowed: orderStatus.filter(function (x) {
                  return ["AWAITING_VALIDATION", "AWAITING_CUSTOMER_VALIDATION", "ADJUSTING", "VALIDATED"].includes(x.id);
                }).map(function (x) {
                  return x.status;
                }),
                excludedPaymentStates: [paymentState.SUCCEEDED, paymentState.PROCESSING],
                departureWarehouseId: _this7.order.id_warehouse,
                notOrderIds: [_this7.order.id_order],
                excludeInvoiced: true
              };
              _this7.isLoadingOrdersAvailable = true;
              _context7.next = 5;
              return request("/v1/orders", "post", data, true, "api").catch(function (e) {
                _this.isLoadingOrdersAvailable = false;
                throw e;
              });
            case 5:
              response = _context7.sent;
              _this7.isLoadingOrdersAvailable = false;
              _this7.ordersAvailable = _toConsumableArray(response.data.orders.filter(function (x) {
                return x.user.user_group != "USER" || x.status != orderStatus.filter(function (os) {
                  return os.id === "VALIDATED";
                })[0].status;
              }).map(function (x) {
                var _x$items;
                return _objectSpread(_objectSpread({}, x), {}, {
                  selectorName: "".concat(x.reference_order.shorterReference(), " / ").concat(orderStatus.find(function (st) {
                    return st.status == x.status;
                  }).shortValue, " / ").concat((_x$items = x.items) === null || _x$items === void 0 ? void 0 : _x$items.reduce(function (acc, item) {
                    return acc + item.quantity;
                  }, 0), " b. on ").concat(x.items.length, " ref. / ").concat(formatPrice(x.total_amount_currency)).concat(getSymbolCurrency(x.currency))
                });
              }));
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee6);
      }))();
    },
    changeOrderDestination: function changeOrderDestination() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.toOrder = [];
              if (!_this8.form.toOrderId) {
                _context8.next = 10;
                break;
              }
              _this8.isLoadingToOrder = true;
              _this = _this8;
              _context8.next = 6;
              return request("/v1/order/" + _this.form.toOrderId, "get", null, true, "api").catch(function (e) {
                if (e.response.data) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "warning"
                  });
                }
                _this.isLoadingToOrder = false;
                throw e;
              });
            case 6:
              response = _context8.sent;
              _this8.toOrder = _objectSpread({}, response.data);
              _this8.isLoadingToOrder = false;
              _this8.itemsSearch();
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee7);
      }))();
    },
    computeAddressStockConsignment: function computeAddressStockConsignment(item) {
      if (item.wine.stock_storage_continent_iso2) {
        return " stored in " + listContinents.find(function (x) {
          return x.id == item.wine.stock_storage_continent_iso2;
        }).display_name;
      } else {
        return item.wineryAddress.city + (item.wineryAddress.zip ? " " + item.wineryAddress.zip : "") + ", " + item.wineryAddress.country.printable_name + (item.wineryAddress.state.id_state ? " " + item.wineryAddress.state.state_label : "");
      }
    },
    isItemPoDanger: function isItemPoDanger(lowestStatusPo) {
      return lowestStatusPo.status === purchaseOrder.status.DRAFT;
    },
    isItemPoWarning: function isItemPoWarning(lowestStatusPo, itemQty) {
      return lowestStatusPo.status === purchaseOrder.status.OPEN && lowestStatusPo.receiptStatus === purchaseOrder.receiptStatus.AWAITING || lowestStatusPo.quantity < itemQty;
    },
    isItemPoSuccess: function isItemPoSuccess(lowestStatusPo, itemQty) {
      return (lowestStatusPo.status === purchaseOrder.status.OPEN || lowestStatusPo.status === purchaseOrder.status.CLOSED) && lowestStatusPo.receiptStatus === purchaseOrder.receiptStatus.RECEIVED && lowestStatusPo.quantity === itemQty;
    },
    getItemPoStatus: function getItemPoStatus(item) {
      var lowestStatusPo = this.getLowestStatusPurchaseOrder(item);
      if (this.isItemPoDanger(lowestStatusPo)) return "danger";
      if (this.isItemPoWarning(lowestStatusPo, item.quantity)) return "warning";
      if (this.isItemPoSuccess(lowestStatusPo, item.quantity)) return "success";
    },
    getLowestStatusPurchaseOrder: function getLowestStatusPurchaseOrder(item) {
      if (item.associatedPurchaseOrders.find(function (x) {
        return x.status === purchaseOrder.status.DRAFT;
      })) return purchaseOrder.status.DRAFT;
      var itemQtyNotFilled = item.associatedPurchaseOrders.find(function (x) {
        return x.quantity < item.quantity;
      });
      if (itemQtyNotFilled) return purchaseOrder.status.DRAFT;
      return Math.min.apply(Math, _toConsumableArray(item.associatedPurchaseOrders.map(function (x) {
        return x.status;
      })));
    },
    initStep: function initStep() {
      var stepId = 1;
      this.steps = [{
        id: stepId,
        key: "toOrder",
        title: "Choose order destination"
      }, {
        id: stepId + 1,
        key: "items",
        title: "Pick the items to be merged"
      }, {
        id: stepId + 2,
        key: "mail",
        title: "Send e-mail(s)",
        inf: "Select an email template and targets to inform stakeholders."
      }, {
        id: stepId + 3,
        key: "synthesis",
        title: "Synthesis"
      }];
      this.currentStep = 1;
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    changePanel: function changePanel() {
      var _this9 = this;
      if (document.querySelector("#expansion-panel_".concat(this.openedPanel && this.openedPanel - 1))) {
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(_this9.openedPanel && _this9.openedPanel - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      }
    },
    deleteTemplatePanel: function deleteTemplatePanel(index) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this10.$refs.confirm.open("Confirm", "Are you sure you want to delete the configuration of this e-mail?");
            case 2:
              isConfirmed = _context9.sent;
              if (isConfirmed) {
                _this10.form.emailTemplates.splice(index, 1);
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee8);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var selectedTemplate, current;
        return _regeneratorRuntime().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.isSyncing = true;
              _context10.next = 3;
              return _this11.fetchEmailTemplates();
            case 3:
              selectedTemplate = _this11.form.emailTemplates[_this11.openedPanel];
              if (!!selectedTemplate.id) {
                current = _this11.emailTemplates.find(function (x) {
                  return x.id === selectedTemplate.id;
                });
                _this11.changeTemplate(current);
              }
              _this11.isSyncing = false;
              _this11.isNeedingSync = false;
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee9);
      }))();
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this12 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this12.templateModalShown = false;
      });
    },
    newTemplate: function newTemplate() {
      var _this13 = this;
      this.$nextTick(function () {
        return _this13.templateModalShown = true;
      });
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this = _this14;
              _context11.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data;
                if ((_e$response$data = e.response.data) !== null && _e$response$data !== void 0 && _e$response$data.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this14.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this14.isNeedingSync = true;else _this14.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee10);
      }))();
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var isConfirmed, _this, rest;
        return _regeneratorRuntime().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this15.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context12.sent;
              if (!isConfirmed) {
                _context12.next = 14;
                break;
              }
              _this15.isDeletingTemplate = true;
              _this = _this15;
              _context12.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to delete this template.", {
                  type: "error"
                });
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context12.next = 10;
              return _this15.fetchEmailTemplates();
            case 10:
              rest = _this15.form.emailTemplates.filter(function (x) {
                return x.id === templateId;
              });
              _this15.form.emailTemplates = _toConsumableArray(rest.length > 0 ? rest : [{
                id: 0,
                files: [],
                sendTo: [],
                mailHistories: []
              }]);
              _this15.editableTemplate = {};
              _this15.isDeletingTemplate = false;
            case 14:
            case "end":
              return _context12.stop();
          }
        }, _callee11);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this = _this16;
              _context13.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to fetch email templates.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context13.sent;
              _this16.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var response;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return request("/v1/mail/placeholders?orderId=".concat(_this17.order.id_order), "get", null, true, "api");
            case 2:
              response = _context14.sent;
              _this17.emailPlaceholders = response.data;
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }))();
    },
    newEmail: function newEmail() {
      var _this18 = this;
      this.form.emailTemplates = [].concat(_toConsumableArray(this.form.emailTemplates), [{
        id: 0,
        sendTo: [],
        files: [],
        mailHistories: []
      }]);
      this.$nextTick(function () {
        var i = _this18.form.emailTemplates.length - 1;
        _this18.openedPanel = i;
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(i && i - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplates.splice(this.openedPanel, 1, _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent)
      }));
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this19.isLoadingFiles = true;
              _this = _this19;
              _context15.next = 4;
              return request("/v1/orders/" + _this19.order.id_order + "/docs", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context15.sent;
              _this19.documents = response.data.reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this19.isLoadingFiles = false;
            case 7:
            case "end":
              return _context15.stop();
          }
        }, _callee14);
      }))();
    },
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    close: function close() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee15$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              isConfirmed = true;
              if (_this20.hasFailedSending) {
                _context16.next = 5;
                break;
              }
              _context16.next = 4;
              return _this20.$refs.confirm.open("Cancel", "Are you sure you want to cancel the merge ?");
            case 4:
              isConfirmed = _context16.sent;
            case 5:
              if (isConfirmed) {
                _this20.currentStep = 1;
                _this20.isStatelessDrawer = false;
                _this20.drawer = false;
                _this20.$emit("close", true);
                _this20.isStatelessDrawer = true;
              }
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee15);
      }))();
    },
    wineNaming: wineNaming,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice
  }
};